<div class="pull-left">    
    <ngb-pagination [collectionSize]="paginationDetails.totalNumberOfItems" [page]="paginationDetails.pageNumber"
        [pageSize]="paginationDetails.itemsPerPage" [maxSize]="5" [rotate]="true" [ellipses]="false"
        [boundaryLinks]="true" (pageChange)="onPageChange($event)"></ngb-pagination>
</div>